"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointError = void 0;
// import { AxiosError } from 'axios';
// export class EndpointError<T = unknown, D = any> extends AxiosError<T, D> {
//   constructor(
//     message?: string,
//     code?: string,
//     config?: InternalEndpointRequestConfig<D>,
//     request?: any,
//     response?: EndpointResponse<T, D>
//   ) {
//     super(message, code, config, request, response);
//   }
// }
class EndpointError {
    constructor(message, code, config) {
        this.message = message;
        this.code = code;
        this.config = config;
    }
}
exports.EndpointError = EndpointError;
//# sourceMappingURL=EndpointError.js.map